import { OnInit, EventEmitter, Output, Input, Directive, OnDestroy } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import {
  ValidationResult,
  validate,
  message,
} from './validate';
import {  map } from 'rxjs/operators';
// @Directive()
@Directive()
export abstract class BaseControlComponent<T>  implements OnInit,OnDestroy {
  protected abstract model: NgModel;
  //value: T;
  ngUnsubscribe = new Subject<void>();
  _pattern: string;
      value: any;
  @Output() valueChange = new EventEmitter<any>();
  @Input() label: string;
  @Input() name: string;
  @Input() id: string;
  @Input() required: boolean = false;
  @Input() hidden: boolean = false;
  @Input() disabled: boolean = false;
  @Input() textType: string = "text";
  @Input() minLength: string;
  @Input() maxLength: string;
  @Input() min: number;
  @Input() max: number;
  @Input() placeholder: string;
  @Input() multiple: boolean = false;
  @Input() pattern: string;
  // @Input() set patternKey(value: string) {
  //   this._pattern = value;
  // }
  get patternKey(): string {
    return this._pattern;
  }
  @Input() mainclass: string = 'col-lg-12 col-sm-12';
  @Input() labelclass: string = 'col-lg-3 col-sm-3';
  @Input() inputclass: string = 'col-lg-9 col-sm-9';
  //private  _formBuilder: FormBuilder;
  public patterns = {
    email: "([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+",
    url: "(https?)://[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]",
    mobile: "^[0-0][9-9]\\d{9}",
    telephone: "^[1-9]\\d{3,7}",
    nationalcode: "^[0-9]\\d{9}",
    lockserial: "^\d{4}-\d{4}-\d{4}",
    number: "^\\d+$",
    minMax: "^$|^([0-9]|[1-9][0-9]|[1][0][0])?"
  };
  constructor(
    private validators: Array<any>,
    private asyncValidators: Array<any>) {
  }
  ngOnDestroy(): void {
    if(this.ngUnsubscribe)
    {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }
  ngOnInit() {
  }
  change(newValue: any) {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
  protected validate(): Observable<ValidationResult> {
    var v = validate(this.validators, this.asyncValidators)(this.model.control);
    return null;
  }
  private patternIsOk() {
    if (this.value && this.patternKey && this.patterns[this.patternKey] && this.model.control.valid) {
      var regex = new RegExp(this.patterns[this.patternKey]);
      if (!regex.test(this.value.toString())) {
        this.model.control.setErrors({ invalid: true });
      }
    }
  }
  private setMinMax() {
    if (this.min && Number(this.value) < Number(this.min))
      this.model.control.setErrors({ min: true });
    if (this.max && Number(this.value) > Number(this.max))
      this.model.control.setErrors({ max: true });
  }
  public get invalid(): Observable<boolean> {
    this.patternIsOk();
    if (this.textType == 'number')
      this.setMinMax();
    if (this.validate() == null) {
      return null;
    }
    return this.validate().pipe(map(v => Object.keys(v || {}).length > 0));
  }
  public get failures(): Observable<Array<string>> {
    if (this.validate() == null) {
      return null;
    }
    return this.validate().pipe(map(v => Object.keys(v).map(k => message(v, k))));
  }
}
